<template>
    <div class="grid" :style="[sideMargins, width]">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Grid',
    props: {
        gap: {
            type: [Number, String],
            default: 20
        },
        gapX: {
            type: [Number, String],
            default: 0
        },
        gapY: {
            type: [Number, String],
            default: 0
        }
    },

    data() {
        const { gap, gapX, gapY } = this;

        return {
            context: {
                gap,
                gapX,
                gapY
            }
        };
    },

    provide() {
        return {
            context: this.context
        };
    },

    computed: {
        sideMargins() {
            return {
                margin: `0 -${Number(this.gapX) / 2 || Number(this.gap) / 2}px`
            };
        },
        width() {
            return { width: `calc(100% + ${Number(this.gapX) || Number(this.gap)}px)` };
        }
    },

    watch: {
        gap(value) {
            this.context.gap = value;
        },
        gapX(value) {
            this.context.gapX = value;
        },
        gapY(value) {
            this.context.gapY = value;
        }
    }
};
</script>

<style lang="scss" src="./Grid.scss"></style>
